if (!customElements.get('sns-share-buttons')) {
  customElements.define(
    'sns-share-buttons',
    class SnsShareButtons extends HTMLElement {
      constructor() {
        super();

        this.copyButton = this.querySelector('[data-sns="copy"]');
        this.message = this.querySelector('.sns-share-buttons__message');
        this.shareUrl = this.dataset.shareUrl || '';

        this.copyButton?.addEventListener('click', this.handleCopy.bind(this));
      }

      connectedCallback() {
        this.updateLinks(this.shareUrl);
      }

      updateUrl(url) {
        this.shareUrl = url;
        this.dataset.shareUrl = url;
        this.updateLinks(url);
      }

      updateLinks(url) {
        if (!url) return;

        const encodedUrl = encodeURIComponent(url);
        const facebook = this.querySelector('[data-sns="facebook"]');
        const x = this.querySelector('[data-sns="x"]');
        const pinterest = this.querySelector('[data-sns="pinterest"]');

        if (facebook) {
          facebook.href = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
        }

        if (x) {
          x.href = `https://twitter.com/intent/tweet?url=${encodedUrl}`;
        }

        if (pinterest) {
          pinterest.href = `https://pinterest.com/pin/create/button/?url=${encodedUrl}`;
        }
      }

      async handleCopy() {
        const url = this.shareUrl;

        if (!url) {
          this.showMessage('No link available');
          return;
        }

        try {
          await this.copyText(url);
          this.showMessage(window.accessibilityStrings?.shareSuccess || 'Link copied to clipboard');
        } catch {
          this.showMessage('Failed to copy link');
        }
      }

      async copyText(text) {
        if (navigator.clipboard?.writeText) {
          try {
            await navigator.clipboard.writeText(text);
            return;
          } catch {
            // Fall through to legacy copy method.
          }
        }

        this.fallbackCopy(text);
      }

      fallbackCopy(text) {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'absolute';
        textarea.style.left = '-9999px';
        document.body.appendChild(textarea);
        textarea.select();

        const success = document.execCommand('copy');
        document.body.removeChild(textarea);

        if (!success) {
          throw new Error('Copy failed');
        }
      }

      showMessage(text) {
        if (!this.message) return;

        this.message.textContent = text;
        this.message.classList.remove('visually-hidden');

        clearTimeout(this.messageTimeout);
        this.messageTimeout = setTimeout(() => {
          this.message.textContent = '';
          this.message.classList.add('visually-hidden');
        }, 2000);
      }
    }
  );
}
